import axios from 'axios';

class AggregateApiClass {
  async getAll() {
    const jobs = await axios.get('/api/aggregates/');
    return jobs.data;
  }

  async deleteById(id: number) {
    await axios.delete('/api/aggregates/' + id);
  }
}

export const AggregateApi = new AggregateApiClass();
